import React from "react";
import { motion } from "framer-motion";
import blogImage1 from "../../assets/blogs/nutrition_for_busy_professionals/b1.jpg";
import blogImage2 from "../../assets/blogs/nutrition_for_busy_professionals/b2.jpg";
import RecentPosts from "../../components/blogs/RecentPosts";
import Footer from "../../components/homepage/Footer"

export default function NutritionForProfessionals() {
  return (
    <>
    <div className="flex max-w-[1200px] mx-auto gap-10 py-16 px-4">
      
      {/* Left Blog Content */}
      <motion.div
        className="w-full lg:w-3/4 flex flex-col gap-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        {/* Main Image */}
        <div className="relative w-full h-[400px] md:h-[500px] rounded-xl overflow-hidden shadow-lg">
          <img
            src={blogImage1}
            alt="Nutrition for Busy Professionals"
            className="w-full h-full object-cover"
          />
          <div className="absolute bottom-0 w-full bg-black/20 p-6 text-white flex flex-col gap-2">
            <h1 className="text-4xl md:text-5xl font-bold drop-shadow-lg">
              Nutrition for Busy Professionals
            </h1>
            <p className="text-gray-200 text-lg">Kalon | November 26, 2025</p>
          </div>
        </div>

        {/* Blog Content */}
        <motion.div
          className="flex flex-col gap-6 text-gray-200 text-lg leading-relaxed"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <p>
            Maintaining proper nutrition while juggling a busy professional life can be challenging.  
            Long hours and constant deadlines often disrupt healthy eating habits.  
            These gaps affect energy and daily output in a clear way.
          </p>

          <h2 className="text-2xl font-semibold text-neonTurquoise mt-6">
            1. Prioritize Meal Planning
          </h2>

          <p>
            Meal planning supports steady intake through the week.  
            Preparing meals early helps prevent reliance on fast food and snacks that offer little value.
          </p>

          <ul className="list-disc list-inside ml-4">
            <li>Batch-cook protein sources like chicken, fish, or tofu.</li>
            <li>Use frozen vegetables for quick, nutrient-dense sides.</li>
            <li>Prepare portable snacks such as nuts, seeds, or protein bars.</li>
          </ul>

          {/* SECTION 2 – TEXT + IMAGE SIDE BY SIDE */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start mt-6">
            
            {/* TEXT LEFT */}
            <div>
              <h2 className="text-2xl font-semibold text-neonTurquoise mb-3">
                2. Prioritize High-Intensity Interval Training (HIIT)
              </h2>

              <p className="mb-3">
                HIIT supports fat reduction and helps maintain lean tissue.  
                This method uses short bursts of effort followed by rest.  
                These sessions help people who prefer simple and short routines.  
                HIIT keeps energy stable because the intensity forces the body to use fuel in a direct and efficient way.  
                These intervals help reduce extra fat without increasing muscle mass beyond what is practical for daily work.  
                People with tight schedules benefit because the sessions are brief yet effective.  
                HIIT keeps the muscles active and supports steady output across the week.  
                When followed with proper rest, HIIT helps maintain a firm and defined shape without long hours of training.
              </p>

              <ul className="list-disc list-inside ml-4">
                <li>Sprint intervals and full-body circuits.</li>
                <li>Combined cardio and strength efforts under 30 minutes.</li>
                <li>Two to three HIIT sessions weekly for metabolic support.</li>
              </ul>
            </div>

            {/* IMAGE RIGHT */}
            <img
              src={blogImage2}
              alt="Functional Strength"
              className="rounded-xl w-full object-cover h-[480px] md:h-[520px] shadow-lg"
            />
          </div>

          <h2 className="text-2xl font-semibold text-neonTurquoise mt-6">
            3. Stay Hydrated
          </h2>
          <p>
            Hydration is essential for sustaining focus through long work hours.  
            Aim for 2–3 liters of water daily.  
            Herbal teas or infused water add simple variety.
          </p>

          <h2 className="text-2xl font-semibold text-neonTurquoise mt-6">
            4. Quick Nutrition Tips for Busy Days
          </h2>
          <ul className="list-disc list-inside ml-4">
            <li>Keep protein-rich snacks at your desk.</li>
            <li>Use meal delivery services with balanced options when traveling.</li>
            <li>Set reminders for water intake.</li>
            <li>Prepare overnight oats or salads for quick meals.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-neonTurquoise mt-6">
            5. Sample Day for a Busy Professional
          </h2>
          <ol className="list-decimal list-inside ml-4">
            <li>7:00 AM – Greek yogurt with oats and berries</li>
            <li>10:00 AM – Almonds + apple</li>
            <li>12:30 PM – Chicken salad with quinoa</li>
            <li>3:30 PM – Protein shake</li>
            <li>6:30 PM – Salmon with vegetables</li>
            <li>9:00 PM – Herbal tea</li>
          </ol>

          <p className="mt-4">
            With consistent habits, busy professionals can support health without disrupting their workflow.  
            Steady meals, hydration, and controlled portions help maintain long-term energy.
          </p>
        </motion.div>
      </motion.div>

      {/* Right Fixed Recent Posts */}
      <div className="hidden lg:block lg:w-1/4 sticky top-20 self-start">
        <RecentPosts />
      </div>
    </div>
    <Footer />

    </>
  );
}
